import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { Playroom } from 'src/app/admin/models/playroom.model';
import { Ramp } from 'src/app/admin/models/ramp.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { RampService } from 'src/app/admin/services/ramp.service';
import { validateRamp} from 'src/app/utils/formValidators';


@Component({
  selector: 'app-add-ramp-modal',
  templateUrl: './add-ramp-modal.component.html',
  styleUrls: ['./add-ramp-modal.component.scss'],
})
export class AddRampModalComponent implements OnInit {

  ramp: Ramp = new Ramp();
  errMsg = '';
  playrooms$ = this.roomService.playrooms$;
  constructor(private modalController: ModalController,private roomService: PlayroomService,private rampService:RampService) { }

  ngOnInit()
   {
    this.roomService.getAllPlayrooms();
    console.log("playrooms$")
    console.log(this.playrooms$)
   }
 addRamp(){
   
  const formValidation = validateRamp(this.ramp);

  this.errMsg = formValidation.errMsg;
  if(formValidation.isValid) {
    this.rampService.addRamp(this.ramp).subscribe(res => {
      this.rampService.getAllRamp({currentPage: 1, itemsPerPage: 100,
        ulaznaQuery: '', izlaznaQuery: '', brojRampeQuery: '',roomNameQuery:'',StatusQuery:''});
      this.dismissModal();
      console.log("addRamp")
      console.log("this.rampp")
   
    },(err) => {
      JSON.stringify(err.error.title);
    });
  }

 
}

  
  dismissModal() {
    this.modalController.dismiss();
  }
}


 